export default __webpack_public_path__ + "static/4-aae29c61239101b08a2c5b014267c370.jpeg";